<template>

<app-table empty-message="There is no additional information captured." :empty="!$_.keys(item.capture).length">

	<app-table-head :layout="layout">

		<app-table-column text="Question" />
		<app-table-column text="Answer" />

	</app-table-head>

	<app-table-body>

		<app-table-row :layout="layout" v-for="(capture, id) in item.capture" :key="id">

			<app-table-cell-text :text="capture.label" />
			<app-table-cell-text :text="capture.value" />

		</app-table-row>

	</app-table-body>

</app-table>

</template>

<script>

export default {

	props: ['item'],

	data: function() {
	
		return {
			layout: '240px 1fr'
		}
	
	}

}

</script>

<style scoped>

</style>